/**
 * Product Reviews — theme-editor re-initialisation only.
 *
 * Judge.me's loader scans for widgets once, on first page load, and marks each one
 * with jdgm--done-setup-widget. When the theme editor replaces this section's DOM
 * after a settings change, the fresh #judgeme_product_reviews div is unmarked and
 * nothing hydrates it, so the reviews render blank in the editor preview.
 *
 * jdgm.initializeWidgets() is Judge.me's public re-scan; it skips widgets that are
 * already set up, so calling it again is safe. Storefront rendering does not depend
 * on this file at all.
 */

const REVIEWS_WIDGET_SELECTOR = '#judgeme_product_reviews';

document.addEventListener('shopify:section:load', (event) => {
  if (!event.target?.querySelector(REVIEWS_WIDGET_SELECTOR)) return;

  window.jdgm?.initializeWidgets?.();
});
